var React = require('react');

function CheckboxChecked (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M18.741,6.243a1.25,1.25,0,0,0-1.748.265l-6.228,8.453L6.78,11.773a1.25,1.25,0,1,0-1.561,1.952l5,4a1.235,1.235,0,0,0,.781.269,1.254,1.254,0,0,0,1.006-.5l7-9.5A1.249,1.249,0,0,0,18.741,6.243Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M22,0H2A2,2,0,0,0,0,2V22a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2A2,2,0,0,0,22,0Zm0,21.75a.25.25,0,0,1-.25.25H2.25a.249.249,0,0,1-.25-.25V2.249A.249.249,0,0,1,2.25,2h19.5a.25.25,0,0,1,.25.25Z","key":1})]);
}

CheckboxChecked.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 24 24"};

module.exports = CheckboxChecked;

CheckboxChecked.default = CheckboxChecked;
